import React from 'react';
import { Table, Tag, Space } from 'antd';

import LevelChart from './levelChart';
import WidgetAjax from '../../../widget/WidgetAjax'

class MarketPosition extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }

    }

    componentDidMount() {
        this.setState({ loading: false });
    }

    render() {
        const { title, id ,options} = this.props;

        const chartValue = options.rank_pos

        const levelDataSource = [
            {
                key: '1',
                name: '市场地位评分',
                age: options.score_pos,
            },
            {
                key: '2',
                name: '市场地位评分百分位数',
                age: options.ptil_pos,
            },
            {
                key: '3',
                name: '该评分下企业违法失信率',
                age: options.r_pos_op,
            },
            {
                key: '4',
                name: '全部企业平均违法失信率',
                age: options.r_illegal_all,
            }
        ];

        const levelColumns = [
            {
                title: '指标名称',
                dataIndex: 'name',
                key: 'name',
                align:"left",
                width: '50%',
                className: 'tableTitle'
            },
            {
                title: '指标值',
                dataIndex: 'age',
                width: '50%',
                align:"left",
                key: 'age',
                className: 'tableTitle'
            },
        ];

        const normDataSource = [
            {
                key: '1',
                name: '资产同业排名',
                age: options.rank_assgro,
            },
            {
                key: '2',
                name: '营收同业排名',
                age: options.rank_vendinc_tp,
            },
            {
                key: '3',
                name: '交易量同业排名',
                age: options.rank_amt_trd,
            },
        ];

        const normColumns = [
            {
                title: '指标名称',
                dataIndex: 'name',
                key: 'name',
                align:"left",
                width: '50%',
                className: 'tableTitle'
            },
            {
                title: '指标值',
                dataIndex: 'age',
                key: 'age',
                align:"left",
                width: '50%',
                className: 'tableTitle'
            },
        ];

        const contrastDataSource = [
            {
                key: '1',
                name: `同地区（${options.region_name}）`,
                age: options.ptil_pos_region,
                miaoshu:'市场地位与同地区企业相比',
                jieguo:options.rank_pos_region
            },
            {
                key: '2',
                name: `同行业（ ${options.nic_name}）`,
                age: options.ptil_pos_indsy,
                miaoshu:'市场地位与同行业企业相比',
                jieguo:options.rank_pos_indsy
            },
            {
                key: '3',
                name: `同经营时长（ ${options.ability_eslength_tp}）`,
                age: options.ptil_pos_eslength_tp,
                miaoshu:'市场地位与同经营时长企业相比',
                jieguo:options.rank_pos_eslength_tp
            },
            {
                key: '4',
                name: `同营收规模（ ${options.ability_vendinc_tp}）`,
                age: options.ptil_pos_vendinc_tp,
                miaoshu:'市场地位与同营收规模企业相比',
                jieguo:options.rank_pos_vendinc_tp,
            },
        ];

        const contrastColumns = [
            {
                title: '比较范围',
                dataIndex: 'name',
                key: 'name',
                align:"left",
                width: '25%',
                className: 'tableTitle'
            },
            {
                title: '百分位',
                dataIndex: 'age',
                width: '25%',
                align:"left",
                key: 'age',
                className: 'tableTitle'
            },
            {
                title: '比较描述',
                dataIndex: 'miaoshu',
                width: '25%',
                align:"left",
                key: 'miaoshu',
                className: 'tableTitle'
            },
            {
                title: '强弱结果',
                dataIndex: 'jieguo',
                width: '25%',
                align:"left",
                key: 'jieguo',
                className: 'tableTitle'
            },
        ];



        return (
            <div className='common-box'>
                <div >
                    <div className='common-top' id={"POSITION_id"} >
                        <div className="img">
                            <img src={require("../../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                        </div>
                        <div className='common-survival' >{title}</div>
                    </div>
                    <div className='common-modular-all' style={{ paddingLeft: '21px' }}>
                        <div className='common-modular-all-modularTitle'>市场地位评分说明</div>
                        <div className='common-modular-all-brief'>
                            <p>市场地位评分：通过分析企业在竞争同业中和供应链上下游中的位置，评估企业的整体市场地位；评分越高，市场地位越高。等级评分对应关系说明，高：(800，1000]，较高：(600，800]，中等：(500，600]，较低：(200，500]，低：(0，200]。</p>
                            <p>违法失信可能性是指根据全量企业数据评估的近3年严重违法失信企业的比例。</p>
                        </div>
                        <div className='common-modular-all-modularTitle'>市场地位评分</div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '60%' }}>
                                <Table size="small" dataSource={levelDataSource} columns={levelColumns} pagination={false} />
                            </div>
                            <div style={{ width: '40%' }} className='common-modular-all-point-chart'>
                            {chartValue!=''?
                                <LevelChart title="市场地位等级" id="marketPosition" value={chartValue}></LevelChart>:''}
                            </div>
                        </div>
                        <div className='common-modular-all-modularTitle'>市场地位评估关键指标</div>
                        <Table size="small" dataSource={normDataSource} columns={normColumns} pagination={false} />
                        <div className='common-modular-all-modularTitle'>市场地位评分比较（百分位）</div>
                        <Table size="small" dataSource={contrastDataSource} columns={contrastColumns} pagination={false} />

                    </div>
                </div>
            </div>
        )
    }
}

export default MarketPosition